// extracted by mini-css-extract-plugin
export default {"itemWrapper":"XfaTemplateItem_itemWrapper__6qGtD"};